/**
 * Un dato de la solicitud dentro de su recuadro: la etiqueta chica arriba y el
 * valor debajo.
 *
 * Lo comparten el listado de solicitudes y la bandeja. `compacto` es para la
 * bandeja, donde las tarjetas viven en cuatro columnas y el mismo tamaño no
 * cabe.
 */
export const DatoEnRecuadro = ({
  etiqueta,
  valor,
  compacto = false,
}: {
  etiqueta: string
  valor: string
  compacto?: boolean
}) => (
  <div
    className={`min-w-0 rounded-md border border-[#D4DDF7] bg-[#F5F7FD] ${
      compacto ? 'px-1.5 py-1.5' : 'px-3 py-2'
    }`}
  >
    <p className={`leading-none text-[#787878] ${compacto ? 'text-[9px]' : 'text-[10px]'}`}>
      {etiqueta}
    </p>
    <p
      className={`mt-1.5 truncate leading-none text-[#121212] ${
        compacto ? 'text-[11px]' : 'text-sm'
      }`}
    >
      {valor}
    </p>
  </div>
)

export default DatoEnRecuadro
